import React, { useState, useEffect } from "react";

import "./Header.css";

import logo from "../../assets/LOGO.png";

import { Link } from "react-router-dom";

const Header = () => {

  const [menuOpen, setMenuOpen] = useState(false);

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {

    const handleScroll = () => {

      if (window.scrollY > 50) {

        setScrolled(true);

      } else {

        setScrolled(false);

      }

    };

    window.addEventListener("scroll", handleScroll);

    return () =>
      window.removeEventListener("scroll", handleScroll);

  }, []);

  const closeMenu = () => {

    setMenuOpen(false);

  };

  return (

    <nav
      id="templatemo-nav"
      className={scrolled ? "nav-scrolled" : ""}
    >

      <div className="nav-container">

        {/* LOGO */}

        <Link
          to="/"
          className="nav-logo"
          onClick={closeMenu}
        >

          <img
            src={logo}
            alt="FIDIN GROUP"
          />

        </Link>

        {/* MOBILE BUTTON */}

        <button
          className={`nav-toggle ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
        >

          <span></span>
          <span></span>
          <span></span>

        </button>

        {/* NAVIGATION LINKS */}

        <ul className={`nav-links ${menuOpen ? "active" : ""}`}>

          <li>
            <Link
              to="/"
              onClick={closeMenu}
            >
              HOME
            </Link>
          </li>

          <li>
            <Link
              to="/about"
              onClick={closeMenu}
            >
              ABOUT
            </Link>
          </li>

          <li>
            <Link
              to="/services"
              onClick={closeMenu}
            >
              SERVICES
            </Link>
          </li>

          <li>
            <Link
              to="/founder"
              onClick={closeMenu}
            >
              OUR FOUNDER
            </Link>
          </li>

          <li>
            <Link
              to="/projects"
              onClick={closeMenu}
            >
              PROJECTS
            </Link>
          </li>

          <li>
            <Link
              to="/gallery"
              onClick={closeMenu}
            >
              GALLERY
            </Link>
          </li>



          <li>
            <Link
              to="/contact"
              onClick={closeMenu}
            >
              CONTACT
            </Link>
          </li>

        </ul>

      </div>

    </nav>
  );
};

export default Header;